/**
 * useRetreatStateManagement.ts — UI state management hook.
 * Extracted from RetreatBridge to separate state orchestration from other concerns.
 * Manages: UI reducer, state initialization, screen derivation.
 */

import { useReducer, useMemo } from "react";
import type { EngineSnapshot } from "@retreats/engine";
import { uiReducer, createInitialUIState } from "../bridge/uiReducer";
import { deriveScreen } from "../bridge/deriveScreen";
import type { AppScreen } from "../bridge/types";

export function useRetreatStateManagement(engineSnapshot: EngineSnapshot) {
  const [uiState, dispatchUI] = useReducer(
    uiReducer,
    undefined,
    createInitialUIState
  );

  // Derive which screen to render based on engine + UI state
  const screen: AppScreen = useMemo(
    () => deriveScreen(engineSnapshot, uiState),
    [engineSnapshot, uiState]
  );

  return {
    uiState,
    dispatchUI,
    screen,
  };
}
